<template>
    <div id="workbench" class="workcall" :class="{'workbenchBorder':workbenchBorder}" v-drag draggable="true"></div>
</template>

<script>
  import { httpAction, getAction } from '@/api/manage'
export default {
  name: "callCenter",
    data() {
      return {
        hasLogin:false,
        options:{},
        skillList:[],
        info:{}
      }
    },
  props: {
    workbenchBorder: {
      type: Boolean,
      required: false,
      default: false
    }
  }, directives: {
    drag (el) {
      let oDiv = el // 当前元素
      // let self = this // 上下文
      // 禁止选择网页上的文字
      oDiv.onmousedown = function (e) {
        // 鼠标按下，计算当前元素距离可视区的距离
        let disX = e.clientX - oDiv.offsetLeft
        let disY = e.clientY - oDiv.offsetTop
        document.onmousemove = function (e) {
          // 通过事件委托，计算移动的距离
          let l = e.clientX - disX
          let t = e.clientY - disY
          // 移动当前元素
          oDiv.style.left = l + 'px'
          oDiv.style.top = t + 'px'
        }
        document.onmouseup = function (e) {
          document.onmousemove = null
          document.onmouseup = null
        }
        // return false不加的话可能导致黏连，就是拖到一个地方时div粘在鼠标上不下来，相当于onmouseup失效
        return false
      }
    }
  },
  created () {
    this.getCallOptions();
  },
  methods: {
    init(){

      if(!this.workbenchBorder) {
        if(!this.options.instanceId){
          this.$message.warning("未绑定坐席，无法发起呼叫!");
          return;
        }
        if (!this.hasLogin) {
          this.initWorkBench();
          window.workbench.changeVisible(true);
        } else {
          console.log(this.hasLogin)
          window.workbench.register(this.skillList); // 想实现自动上线在此注册
          window.workbench.changeVisible(true);

        }
        this.updateStatus(true);
      }
    },close(){
      window.workbench.logOut();
      //this.workbenchBorder = false;
      window.workbench.changeVisible(false);
      this.updateStatus(false);
    },updateStatus(workbenchBorder){
      this.$emit("getStatus",workbenchBorder)
    },
    //云呼相关初始化
    initWorkBench(){
      let self = this;
      window.workbench = new window.WorkbenchSdk({
        accessKeyId:this.options.accessKeyId,
        accessKeySecret:this.options.accessKeySecret,
        RPCEndPoint:"https://ccc.cn-shanghai.aliyuncs.com",
        apiVersion:"aliyunrpc",
        dom: 'workbench', // 挂载的元素
        regionId:this.options.regionId,
        width: '280px', // 面板的宽
        height: '580px', // 面板的高
        instanceId: this.options.instanceId,
        afterCallRule: 15,  // 挂机后的话后处理时间
        header: true,
        defaultVisible:false,
        defaultMainContentVisible:false,
        //exportErrorOfApi: true,
        moreActionList: ["online","onlyCall", 'break', 'offline'],
        sideNavList:[ "设备检测"],
        onInit: function () {
          window.workbench.register(self.skillList); // 想实现自动上线在此注册
           //可以实现初始化后显示面板
        },onRegister(config){
          console.log("注册后的参数",config)
          window.workbench.logIn(self.skillList);
          self.hasLogin = true;
        },
        onErrorNotify: function (error) {
          console.warn(error)
        },
        onCallComing: function (connid,caller,calee,contactId,skillgroupId) {
          // connid: 通话id;caller: 主叫号码;calee:被叫号码;contactId:录音id，通话记录查询需要的字段;skillgroupId:技能组id
          //eventBus.phone = caller; //将获取的号码，先赋值
          //eventBus.$emit("callComming",caller); // 传递给非父子组件

        },
        onCallDialing: function (info) {
          console.log("挂机",info);
          self.info= info;
          self.saveCallRecord(0)
        },
        onStatusChange: function (code, lastCode, context) {
          // console.log(code, lastCode, context);
        },
        onCallEstablish: function (connid, caller, calee, contactId) {
          // console.log('这里是通话建立时触发的回调函数', connid, caller, calee, contactId)
          self.saveOrUpdateCallStatus();
          self.saveCallRecord(1)
        },
        onCallRelease: function (connid, caller, calee, contactId) {
          // console.log('这里是通话结束时触发的回调函数', connid, caller, calee, contactId)
          window.workbench.ready();
          self.closeDeriver();
          self.saveCallRecord(2)
        },
        onHangUp(type){
          // console.log("挂机");
          //eventBus.phone = "";
        },
        onStatusChange(code, lastCode, context){
          console.log(code, lastCode, context);
          if(window.workbench.driverId){
            console.log(window.workbench.driverId)
          }

        }
      })
    },getCallOptions(){
      var that = this;
      getAction("/dm/dmCallOptions/getMyCallOptions", {}).then((res) => {
        if (res.success) {
          let options = res.result;
          if(options){
            that.options = options;
            if(options.skillList){
              this.skillList = [];
              for(let k in options.skillList){
                that.skillList.push({
                  "skillGroupId":options.skillList[k].skillGroupId,
                  "skillGroupName":options.skillList[k].skillGroupName,
                  "skillLevel":options.skillList[k].skillLevel,
                });
              }
            }
          }

        }
      });
    },saveOrUpdateCallStatus(){
      if(!window.workbench.driverId){
        return;
      }
      let formData = {
        "driverId":window.workbench.driverId
      }
      getAction("/dm/dmDriverCall/createCall",formData).then((res)=>{
        if(res.success){

        }
      })
    },closeDeriver(){
      if(!window.workbench.driverId){
        return;
      }
      let formData = {
        "driverId":window.workbench.driverId
      }
      getAction("/dm/dmDriverCall/stopCall",formData).then((res)=>{
        if(res.success){

        }
      })
    },saveCallRecord(status){

      let formData={
        connid:this.info.jobId,
        driverId:window.workbench.driverId,
        caller:this.info.caller,
        callee:this.info.callee,
        status:status
      }
      console.log("formData:",formData)
      httpAction("/dm/dmDriverCallRecord/add",formData,"post").then((res)=>{
        if(res.success){

        }
      })
    }
  }
}
</script>

<style scoped>
  .workcall{
    z-index: 1001;
    position: fixed;
    top: 50px;
    right: 10px;
    width: 325px;
    background: #fff;
  }
  .workbench_sdk_components-ReducePanel-___style__OnAndOff-box{
    background: #00ff80;
  }
</style>